// extracted by mini-css-extract-plugin
export default {"wrapper":"historicalTrend_wrapper__0kUSY"};